import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import PingIcon from '../svg_icons/indicator_ping_icon';
import Env from '../../env';
import { ServerStatusValue } from '../../features/server_status/server_status_slice';

const PingIndicator = () => {
  const pingStatus = useSelector((state) => state.serverStatus.serverStatus);

  let iconSx = {
    color: '#F8485E',
  };
  if (pingStatus === ServerStatusValue.Checking) {
    iconSx = {
      color: '#FFB830',
    };
  } else if (pingStatus === ServerStatusValue.Ready) {
    iconSx = {
      color: '#CDF3A2',
    };
  }

  const advancedRecipeEditorFeatures = Env.ADVANCED_RECIPE_EDITOR_ENABLED;

  return (
    advancedRecipeEditorFeatures && (
      <div className="pingIndicator">
        <Box sx={iconSx} title={pingStatus}>
          <PingIcon />
        </Box>
      </div>
    )
  );
};

export default PingIndicator;
